import React from 'react';

import HeaderLabel from '../header-label/HeaderLabel';
import { USER_ROLES } from '../../../constants';
import IsGranted from '../../../components/is-granted/IsGranted';

import scss from './HeaderAddButton.module.scss';

function HeaderAddButton({
  label,
  onClick,
  permissions = [
    USER_ROLES.GLOBAL_ADMIN,
    USER_ROLES.GLOBAL_USER,
    USER_ROLES.COMPANY_ADMIN,
    USER_ROLES.COMPANY_USER,
    USER_ROLES.ROLE_CUSTOMER,
  ],
}) {
  return (
    <div className={scss.wrapper}>
      <HeaderLabel>{label}</HeaderLabel>
      <IsGranted permissions={permissions}>
        <button className={scss.button} onClick={onClick}>
          +
        </button>
      </IsGranted>
    </div>
  );
}

export default HeaderAddButton;
